$(document).ready(function(){

    $('body').on('click', '.grid__item .grid-product__content .grid-product__image-mask button.quick-buy-button', function(e){
        e.preventDefault();
        $('.quick-buy-purchasing').hide();
        $(this).nextAll('.quick-buy-purchasing').show();
    });

    $('body').on('mouseleave', '.grid__item .grid-product__content .grid-product__image-mask', function(){
        $(this).find('.quick-buy-purchasing').hide();
    });

    // Once a shopper swipes the nudged first product image, stop the nudge-hint animation for good.
    $('body').on('touchstart pointerdown', '.grid-product--first .grid-product__link', function(){
        $(this).closest('.grid-product--first').addClass('nudge-interacted');
    });

});